<!-- 我的地址 -->
<template>
  <div class="address-container">
    <div class="top-search">
      <header class="title">
        <span class="title-text">我的地址</span>
      </header>
      <el-tabs v-model="activeName" class="bottom-tabs">
        <el-tab-pane label="我的地址" name="first">
          <el-form ref="form" class="address-form" :model="addressForm">
            <el-form-item>
              <!-- <el-input v-model="addressForm.name" suffix-icon="iconfont el-icon-search" placeholder="输入收货人姓名/联系方式查询" /> -->
              <el-input v-model="addressForm.fname" placeholder="输入收货人姓名/联系方式查询">
                <el-button slot="append" class="searchButton" @click="getAddressList">搜索</el-button>
              </el-input>
            </el-form-item>
            <el-button v-if="rols('新增')" class="form-button" @click="handleAddressDialogadd('新增收货地址')">
              <svg-icon icon-class="add-red" /> 新增地址
            </el-button>
          </el-form>
          <!--下方表格-->
          <div class="address-bottom-table">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              fit
              :header-cell-style="{ background: '#fff', color: '#202020', fontSize: '16px', height: '53px' }"
              :row-style="{ height: '53px' }"
            >
              <!-- :cell-style="{ textAlign: 'left' }" -->
              <el-table-column label="序号" type="index" width="150" align="left" />
              <el-table-column label="姓名" prop="fname" width="150" />
              <el-table-column prop="fphoneNo" label="联系方式" width="200" />
              <el-table-column prop="faddress" label="地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.faddress }}</span>
                  <span v-if="scope.row.fdefault" class="default-address-tip">默认</span>
                  <span v-else class="default-address" @click="setDefault(scope.row.fid)">
                    <svg-icon style="margin-right:5px;vertical-align: text-bottom;" icon-class="red-set" />
                    设为默认
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="130" align="right" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="bottom-operation">
                    <span
                      v-if="rols('修改')"
                      style="float:left"
                      class="one-icon"
                      @click="handleAddressDialog('修改地址', scope.row.fid)"
                    >
                      修改
                    </span>
                    <span v-if="rols('删除')" style="float:right" class="one-icon" @click="removeAddress(scope.row.fid)">
                      删除
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="remove-address-dialog">
      <el-dialog center title="删除" width="400px" :visible.sync="removeDialog">
        <img src="@/assets/images/remove-err.png" alt="">
        <p class="remove-tip">确认要删除该条地址信息吗?</p>
        <div class="remove-address-close">
          <el-button @click="removeDialog = false">取消</el-button>
          <el-button @click="remove">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 收货地址新增/修改 -->
    <div class="add-address-dialog">
      <el-dialog :title="title" :visible.sync="addAddressDialog" width="30%" center @close="handleClose">
        <div @click="addressclose">
          <el-form ref="addAddressForm" :model="addAddressForm" label-width="130px">
            <el-form-item label="收货人">
              <el-input v-model="addAddressForm.name" placeholder="请输入收货人姓名" autocomplete="off" />
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input v-model="addAddressForm.mobile" maxlength="11" placeholder="请输入手机号" autocomplete="off" />
            </el-form-item>
            <el-form-item label="选择地区">
              <div style="position: relative">
                <div class="address" @click.stop="changeaddress">
                  <el-input v-model="addAddressForm.address" readonly placeholder="请输入内容" />
                  <svg-icon :class="{ 'arrowTransform': !flag, 'arrowTransformReturn': flag }" icon-class="xia" />
                </div>
                <div v-show="flag" class="address-down" @click.stop="abc">
                  <el-tabs ref="elTabs" type="border-card">
                    <el-tab-pane :label="tagAdderr(addressAll)">
                      <div style="width:">
                        <template>
                          <el-tag
                            v-for="(item, index) in addressAll"
                            v-bind="tagColor(item)"
                            @click.stop="addxz1(item.fname, item.fid, index)"
                          > {{ item.fname }}</el-tag>

                        </template>

                      </div>
                    </el-tab-pane>

                    <template v-if="address2.length">
                      <el-tab-pane :label="tagAdderr(address2)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address2"
                              v-bind="tagColor(item)"
                              @click.stop="addxz2(item.fname, item.fid, index)"
                            > {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>

                    <template v-if="address3.length">
                      <el-tab-pane :label="tagAdderr(address3)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address3"
                              v-bind="tagColor(item)"
                              @click.stop="addxz3(item.fname, item.fid, index)"
                            > {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>

                    <template v-if="address4.length">
                      <el-tab-pane :label="tagAdderr(address4)">
                        <div style="width:">
                          <template>
                            <el-tag
                              v-for="(item, index) in address4"
                              v-bind="tagColor(item)"
                              @click.stop="addxz4(item.fname, item.fid, index)"
                            > {{ item.fname }}</el-tag>

                          </template>

                        </div>
                      </el-tab-pane>
                    </template>

                  </el-tabs>
                  <!-- <div v-show="add1" class="add">
                    <div
                      v-for="(item,index) in address1"
                      :key="index"
                      :class="item.class?'box-blue':'box'"
                      @click.stop="addxz1(item.fname,item.fid,index)"
                    >
                      {{ item.fname }}
                      <span class="el-icon-arrow-right" />
                    </div>
                  </div>
                  <div v-show="add2" class="add">
                    <div v-for="(item,index) in address2" :key="index" :class="item.class?'box-blue':'box'" @click.stop="addxz2(item.fname,item.fid,index)">
                      {{ item.fname }}
                      <span class="el-icon-arrow-right" />
                    </div>
                  </div>
                  <div v-show="add3" class="add">
                    <div v-for="(item,index) in address3" :key="index" :class="item.class?'box-blue':'box'" @click.stop="addxz3(item.fname,item.fid,index)">
                      {{ item.fname }}
                      <span class="el-icon-arrow-right" />
                    </div>
                  </div>
                  <div v-show="add4" class="add">
                    <div v-for="(item,index) in address4" :key="index" :class="item.class?'box-blue':'box'" @click.stop="addxz4(item.fname,item.fid,index)">
                      {{ item.fname }}
                    </div>
                  </div> -->
                </div>
              </div>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="addAddressForm.addressInfo" resize="none" placeholder="请输入详细地址" type="textarea" autocomplete="off" />
            </el-form-item>
            <el-form-item label="设为默认收货地址">
              <el-switch v-model="addAddressForm.delivery" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-form>
          <div class="add-address-close">
            <el-button @click="addAddressDialog = false">取消</el-button>
            <el-button @click="determine">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
import { addUseraddress, queryArea, page, queryUseraddress, updateDefault, updateUseraddress, deleteUseraddress } from '@/api/address'
export default {
  components: {},
  data() {
    return {
      fid: null, // 编辑fid
      options: regionData,
      selectedOptions: [],
      list: null,
      pageNo: 1,
      pageSize: 100,
      total: 0,
      activeName: 'first',
      listLoading: true,
      title: '', // 新增或修改dialogtitle
      removeDialog: false, // 删除地址弹窗
      addAddressDialog: false, // 新增收货地址
      addressForm: {
        fname: ''
      }, // 列表查询条件
      addAddressForm: {
        name: '',
        mobile: '',
        address: '',
        addressInfo: '',
        delivery: ''
      }, // 新增收货地址
      tableData: [],
      // 跟注册相同
      flag: false,
      addressAll: [],
      address1: [],
      address2: [],
      address3: [],
      address4: [],
      add1: false,
      add2: false,
      add3: false,
      add4: false,
      addname1: {
        fid: null,
        fname: ''
      },
      addname2: {
        fid: null,
        fname: ''
      },
      addname3: {
        fid: null,
        fname: ''
      },
      addname4: {
        fid: null,
        fname: ''
      }
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('我的地址')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    },
    tagColor() {
      return (item) => {
        return item.class ? { style: 'color:#fff;', color: '#EC212D' } : { color: '#fff', style: 'color:#000;border:none;' }
      }
    },
    tagAdderr() {
      return (arr = []) => {
        const next = arr.find(item => item.class)
        return next ? next.fname : '请选择'
      }
    }

  },
  created() {
    this.onsearch()
    queryArea({ fid: 0 }).then(res1 => {
      queryArea({ fid: res1[0].fid }).then(res => {
        this.address1 = res
        this.address1.map(item => {
          item.class = false
        })
        this.addressAll = JSON.parse(JSON.stringify(this.address1))
        this.add1 = true
      })
    })
  },
  methods: {

    // 删除
    remove() {
      deleteUseraddress({ fid: this.fid }).then(res => {
        if (res.result) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.onsearch()
          this.removeDialog = false
        }
      })
    },
    // 页面渲染
    onsearch() {
      page({ pageNo: this.pageNo, pageSize: this.pageSize, jsonobj: this.addressForm }).then(res => {
        this.tableData = res.rows
        this.tableData.map(item => {
          const a = item.faddress.split(',')
          let b = ''
          a.map(items => {
            b = b + items
          })
          item.faddress = b
        })
        this.total = res.total
      })
    },
    // 占位事件
    abc() {
      //   console.log('1')
    },
    // 地址弹窗关闭
    addressclose() {
      if (this.address2.length && this.addname2.fid == null) return
      if (this.address3.length && this.addname3.fid == null) return
      this.flag = false
    },
    // 省
    addxz1(fadd, fid, index) {
      this.addname1.fname = fadd
      this.addname2.fname = ''
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname1.fid = fid
      this.addname2.fid = null
      this.addname3.fid = null
      this.addname4.fid = null
      this.address1.map(item => {
        item.class = false
      })
      this.addressAll.map(item => {
        item.class = false
      })
      this.addressAll[index].class = true
      this.address3 = []
      this.address4 = []
      queryArea({ fid: fid }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname
          this.add1 = true
          this.add2 = false
          this.add3 = false
          this.add4 = false
          this.flag = false
          this.address2 = []
        } else {
          this.address2 = res
          this.address2.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.$refs.elTabs.currentName = '1'
        }
      })
    },
    // 市
    addxz2(fadd, fid, index) {
      this.addname2.fname = fadd
      this.addname3.fname = ''
      this.addname4.fname = ''
      this.addname2.fid = fid
      this.addname3.fid = null
      this.addname4.fid = null
      // this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname
      this.address2.map(item => {
        item.class = false
      })
      this.address2[index].class = true
      this.address4 = []
      queryArea({ fid: fid }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname
          this.add1 = true
          this.add2 = true
          this.add3 = false
          this.add4 = false
          this.flag = false
        } else {
          this.address3 = res
          this.address3.map(item => {
            item.class = false
            this.add1 = true
            this.add2 = true
            this.add3 = true
            this.add4 = false
          })
          this.$refs.elTabs.currentName = '2'
        }
      })
    },
    // 县
    addxz3(fadd, fid, index) {
      this.addname3.fname = fadd
      this.addname4.fname = ''
      this.addname3.fid = fid
      this.addname4.fid = null
      this.address3.map(item => {
        item.class = false
      })
      this.address3[index].class = true
      queryArea({ fid: fid }).then(res => {
        if (res.length === 0) {
          this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname + '/' + this.addname3.fname
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = false
          this.flag = false
        } else {
          this.address4 = res
          this.address4.map(item => {
            item.class = false
          })
          this.add1 = true
          this.add2 = true
          this.add3 = true
          this.add4 = true
          this.$refs.elTabs.currentName = '3'
        }
      })
    },
    // 街道
    addxz4(fadd, fid, index) {
      this.addname4.fname = fadd
      this.addname4.fid = fid
      this.addAddressForm.address = this.addname1.fname + '/' + this.addname2.fname + '/' + this.addname3.fname + '/' + this.addname4.fname
      this.address4.map(item => {
        item.class = false
      })
      this.address4[index].class = true
      this.flag = false
      this.$forceUpdate()
    },
    // 地址点击事件
    changeaddress() {
      if (this.flag && this.address2.length && this.addname2.fid == null) return
      if (this.flag && this.address3.length && this.addname3.fid == null) return
      this.flag = !this.flag
      this.$refs.elTabs.currentName = '0'
    },
    // 保存地址

    determine() {
      if (!this.addAddressForm.name) return this.$message.warning('请输入收货人')
      if (!this.addAddressForm.mobile) return this.$message.warning('请输入联系方式')
      let id = null
      let name = ''
      if (this.addname4.fname === '') {
        if (this.addname3.fname === '') {
          if (this.addname2.fname === '') {
            if (this.addname1.fname !== '') {
              id = this.addname1.fid
              name = this.addname1.fname
            }
          } else {
            id = this.addname2.fid
            name = this.addname2.fname
          }
        } else {
          id = this.addname3.fid
          name = this.addname3.fname
        }
      } else {
        id = this.addname4.fid
        name = this.addname4.fname
      }
      if (!id) return this.$message.warning('请选择收货地址')
      if (!this.addAddressForm.addressInfo) return this.$message.warning('请输入详细地址')
      if (this.title === '新增收货地址') {
        addUseraddress({
          faddress: this.addAddressForm.addressInfo,
          fdefault: this.addAddressForm.delivery||0,
          fareaId: id,
          fareaName: name,
          fname: this.addAddressForm.name,
          fphoneNo: this.addAddressForm.mobile
        }).then(res => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.onsearch()
            this.addAddressDialog = false
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        updateUseraddress({
          fid: this.fid,
          faddress: this.addAddressForm.addressInfo,
          fdefault: this.addAddressForm.delivery,
          fareaId: id,
          fareaName: name,
          fname: this.addAddressForm.name,
          fphoneNo: this.addAddressForm.mobile
        }).then(res => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.onsearch()
            this.addAddressDialog = false
          }
        })
      }
    },
    // 地址搜索
    getAddressList() {
      this.onsearch()
    },
    // 新增收货地址
    handleAddressDialogadd(title) {
      this.title = title
      this.addAddressDialog = true
    },
    // 编辑
    handleAddressDialog(title, fid) {
      this.title = title
      this.fid = fid
      queryUseraddress({ fid: fid }).then(res => {
        this.addAddressForm.name = res.fname
        this.addAddressForm.mobile = res.fphoneNo
        this.addAddressForm.address = res.fareaName.split(',').join('/')
        this.addAddressForm.addressInfo = res.faddress
        this.addAddressForm.delivery = res.fdefault
        const a = res.fareaIds.split(',')
        const d = res.fareaIds.split(',')
        a.splice(a.length - 1, 1)
        a.unshift(0)
        a.map((item, index) => {
          queryArea({ fid: item }).then(res => {
            const b = 'address' + (index + 1)

            if (index + 1 === 1) {
              this.addressAll.forEach(itemds => {
                if (itemds.fid === Number(d[index])) {
                  itemds.class = true
                  this['addname' + (index + 1)].fid = itemds.fid
                  this['addname' + (index + 1)].fname = itemds.fname
                } else {
                  itemds.class = false
                }
              })
            }
            this[b] = res
            this[b].map(items => {
              if (items.fid === Number(d[index])) {
                items.class = true
                this['addname' + (index + 1)].fid = items.fid
                this['addname' + (index + 1)].fname = items.fname
              } else {
                items.class = false
              }
            })
            const c = 'add' + (index + 1)
            this[c] = true
            this.$forceUpdate()
          })
        })
      })
      this.addAddressDialog = true
    },
    /**
     * 收货地址弹窗关闭
     */
    handleClose() {
      this.address2 = []
      this.address3 = []
      this.address4 = []
      this.add2 = false
      this.add3 = false
      this.add4 = false
      this.addname1 = {
        fid: null,
        fname: ''
      }
      this.addname2 = {
        fid: null,
        fname: ''
      }
      this.addname3 = {
        fid: null,
        fname: ''
      }
      this.addname4 = {
        fid: null,
        fname: ''
      }
      this.flag = false
      this.addAddressForm = {
        name: '',
        mobile: '',
        address: '',
        addressInfo: '',
        delivery: ''
      }
      this.addAddressDialog = false
    },
    // 删除弹窗
    removeAddress(fid) {
      this.fid = fid
      this.removeDialog = true
    },
    /**
     * 设为默认地址
     */
    setDefault(fid) {
      this.$confirm('是否将此地址设为默认地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateDefault({ fid: fid }).then(res => {
          if (res.result) {
            this.$message({
              type: 'success',
              message: '设置成功!'
            })
            this.onsearch()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消设置'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.address-container {
  background: #ffffff;
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .commodity-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .address-form {
    display: flex;
    justify-content: space-between;
    padding: 20px 11px;
    background-color: #fff;

    .searchButton {
      width: 69px;
      height: 36px;
    }
  }

  .address {
    position: relative;

    .arrowTransform {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -6px;
      transition: 0.2s;
      transform-origin: center;
      transform: rotateZ(180deg);
    }

    .arrowTransformReturn {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -6px;
      transition: 0.2s;
      transform-origin: center;
      transform: rotateZ(0deg) ;
    }
  }

  .address-down {
    position: absolute;
    top: 28px;
    left: 0px;
    z-index: 1000;
    display: flex;
    margin: 5px 0;
    font-size: 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    overflow: auto;

    .add {
      overflow-y: auto;
      height: 170px;
      width: 147px;

      .box {
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 30px;
        height: 34px;
        line-height: 34px;
        outline: none;

        .el-icon-arrow-right {
          position: absolute;
          right: 10px;
        }
      }

      .box-blue {
        color: skyblue;
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 30px;
        height: 34px;
        line-height: 34px;
        outline: none;

        .el-icon-arrow-right {
          position: absolute;
          right: 10px;
        }
      }
    }
  }

  .title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    line-height: 36px;
    background-color: #ec212d;

    .title-text {
      color: #fff;
      font-size: 16px;
      margin-left: 11px;
    }
  }

  .bottom-tabs {
    height: 93%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .top-search {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .form-button {
    // width: 175px;
    height: 24px;
    font-size: 12px;
    line-height: 0;
    color: #ec212d;
    background: #fff;
    border: 1px solid #ec212d;
    border-radius: 4px;
    padding: 0 10px;
  }

  .remove-address-dialog {
    img {
      width: 102px;
      height: 66px;
    }

    .remove-tip {
      margin: 9px 0 22px 0;
      font-size: 18px;
      color: #333;
    }

    button {
      width: 135px;
      height: 30px;
      line-height: 30px;
      padding: 0;
    }

    .remove-address-close button:first-child {
      color: #ec212d;
      background-color: #fff;
      border: 1px solid #ec212d;
    }

    .remove-address-close button:last-child {
      color: #fff;
      background-color: #ec212d;
      border: 1px solid #ec212d;
    }
  }

  .default-address-tip {
    background: #ec212d;
    color: #fff;
    border-radius: 3px;
    padding: 2px 7px;
    margin-left: 9px;
    font-size: 16px;
  }

  .add-address-dialog {
    .add-address-close {
      border-top: 1px solid rgb(223, 227, 234);
      height: 60px;
      padding: 0 25px;
      display: flex;
      justify-content: right;
      align-items: center;
    }

    button {
      width: 80px;
      height: 36px;
      line-height: 36px;
      padding: 0;
    }

    .add-address-close button:first-child {
      color: #ec212d;
      background-color: #fff;
      border: 1px solid #ec212d;
    }

    .add-address-close button:last-child {
      color: #fff;
      background-color: #ec212d;
      border: 1px solid #ec212d;
    }
  }

  .address-bottom-table {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    margin-top: 16px;

    .commodity-pagination {
      text-align: center;
      margin-top: 10px;
    }

    .bottom-operation {

      //   display: flex;
      //   justify-content: flex-start;
      //   align-items: center;
      svg {
        margin-right: 22px;
      }
    }

    .default-address {
      font-size: 16px;
      font-weight: 400;
      color: #ec212d;
      cursor: pointer;
      display: none;
      margin-left: 30px;
    }
  }

  .one-icon {
    // width: 16px;
    // height: 16px;
    cursor: pointer;
    color: rgb(236, 33, 45)
  }
}
</style>
<style lang="scss">
.add-address-dialog {
  .el-dialog__body {
    padding: 25px 0 0 0;
  }

  .el-form {
    padding: 0 25px 10px;
  }
}

.address-container {

  /**我的地址header的tab样式 */
  .el-tabs__header {
    margin: 0;
    height: 0px;

    .el-tabs__nav-wrap,
    .el-tabs__nav-scroll,
    .el-tabs__nav {
      height: 100%;
      line-height: 66px;
    }

    .el-tabs__nav {
      width: 92px;
      text-align: center;
    }

    .el-tabs__active-bar {
      width: 92px !important;
    }
  }

  .address-down {
    width: 394px;

    .el-tabs__item {
      height: 32px;
      line-height: 32px;
    }

    .el-tabs__header {
      height: auto;
    }

    .el-tabs__header .el-tabs__nav {
      width: auto;
    }

    .el-tabs__header .el-tabs__nav-scroll,
    .el-tabs__header .el-tabs__nav,
    .el-tabs__header .el-tabs__nav-wrap {
      line-height: normal;
      height: auto;
    }

    .el-tag {
      padding: 0 7px;
      line-height: 26px;
      height: 26px;
      margin: 0 5px;
      cursor: pointer;
      min-width: 52px;
    }
    .el-tag:hover{
      background-color:#EC212D !important;
      color:#fff !important;
    }
    .el-tabs__item{
      color:#000;
    }
    .is-top .is-active{
      background-color:#EC212D !important;
      color:#fff !important;
    }
    .el-tabs--border-card>.el-tabs__content {
      padding: 8px;
    }
  }

  .el-dialog {
    border-radius: 10px;
    margin: 0 !important;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .el-dialog__header {
    border-radius: 10px 10px 0 0;
  }

  .address-form {
    .el-form-item__content {
      margin-right: 20px;
    }
  }

  .top-search {
    .el-form-item__label {
      font-size: 12px;
      padding: 0 7px 0 0;
    }

    .el-input__inner {
      height: 36px;
      padding: 5px;
      width: 235px;
      margin-right: 22px;
    }

    .el-form-item {
      margin: 0;
    }

    .el-tab-pane {
      height: 100%;
      min-height: 38.5vh;
      display: flex;
      flex-direction: column;
    }

    .el-input-group__append button.el-button {
      background-color: #ec212d;
      color: #fff;
      padding: 5px 10px;
      border: none;
      font-size: 14px;
    }

    .form-button .el-icon-search {
      margin-right: 5px;
      font-weight: 700;
    }
  }

  .address-bottom-table {
    .el-table {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .el-table__header-wrapper {
      overflow: revert;
      height: 38px;
    }

    .el-table__body-wrapper {
      height: 580px;
      overflow-y: auto;
    }

    .el-table::before {
      height: 0;
    }

    .el-table--enable-row-hover .el-table__body tr:hover {
      background-color: #fde8ea;
    }

    .el-table tbody tr:hover>td {
      border-top: 1px solid #ec212d;
      border-bottom: 1px solid #ec212d;
      background-color: #fde8ea;
    }

    .el-table tbody tr:hover>td:first-child {
      border-left: 1px solid #ec212d;
    }

    .el-table tbody tr:hover>td:nth-child(5) {
      border-right: 1px solid #ec212d;
    }

    .el-table__body .el-table__row.hover-row td {
      background-color: #fde8ea;
    }

    .el-table tbody tr:hover {
      .default-address {
        display: inline-block;
      }
    }

    th {
      padding: 5px;
    }

    td {
      font-size: 16px;
      padding: 5px;
    }
  }

  .remove-address-dialog {
    .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
